module.exports = __webpack_public_path__ + "img/0000.f6911516.png";